import { render } from "./HomeWaiting.vue?vue&type=template&id=0700dd43"
import script from "./HomeWaiting.vue?vue&type=script&lang=js"
export * from "./HomeWaiting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__